import React from "react";
import {BrowserRouter, Navigate, Route, Routes} from "react-router-dom";
import SiteLayout from "../layouts/chase/SiteLayout";
import AdventurersRouter from "./cga/AdventurersRouter";
import Home from "../pages/chase/home/Home";
import MissingPage from "../pages/chase/400/MissingPage";
import ErrorPage from "../pages/chase/500/ErrorPage";
import QrCodeLandingPage from "../pages/chase/qr-landing/QrCodeLandingPage";
import RedirectsRouter from "./RedirectsRouter";
import StoryRouter from "./chase/StoryRouter";
import ArtRouter from "./chase/ArtRouter";
import FunRouter from "./chase/FunRouter";
import SiteInfoRouter from "./chase/SiteInfoRouter";
import StreamRouter from "./chase/StreamRouter";

interface SiteRouterProps {
}

class SiteRouter extends React.Component<SiteRouterProps> {

    render() {
        return (
            <BrowserRouter>
                <Routes>
                    <Route path="/" element={<SiteLayout/>}>
                        <Route index element={<Home/>}/>
                        <Route path="home" element={<Navigate replace to="/"/>}/>
                        {StoryRouter.getRoutes()}
                        {StreamRouter.getRoutes()}
                        {ArtRouter.getRoutes()}
                        {FunRouter.getRoutes()}
                        {SiteInfoRouter.getRoutes()}
                        <Route path="qr">
                            <Route index element={<QrCodeLandingPage/>}/>
                        </Route>
                        <Route path="cga">
                            {AdventurersRouter.getRoutes("/cga")}
                        </Route>
                        {RedirectsRouter.getRoutes()}
                        <Route path="error" element={<ErrorPage/>}/>
                        <Route path="404" element={<MissingPage/>}/>
                        <Route path="*" element={<Navigate replace to={"/404"}/>}/>
                    </Route>
                </Routes>
            </BrowserRouter>
        );
    }
}

export default SiteRouter;